/**
 * * @module component/logos.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";

const Logos = Backbone.View.extend({
  el: $(document),

  initialize: function () {
    this.render();
  },

  resizeBoxes: function () {
    let height = 0;
    const $items = $(".supporters .logo-block-image");
    
    $items.each(function () {
      const $box = $(this);
      const itemHeight = $box.height();
      if(itemHeight > height){
        height = itemHeight
      }
    });
    $items.height(height);
  },

  manageResizingOfBoxes: function () {
    var _this = this;

    // _this.resizeBoxes();

    // $(window).resize(function () {
    //   _this.resizeBoxes();
    // });
  },

  render: function () {
    this.manageResizingOfBoxes();
  },
});

export default Logos;
